import React from 'react';
import { renderToString } from 'react-dom/server';

import { AddressCardIcon } from '../../../icon/regular';
import {
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class TitleInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return TitleInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    TitleInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.TITLE_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.TITLE_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.TITLE_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<AddressCardIcon style={{ height: 20 }} />),
      title: 'Title',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.title;
  }

  async openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_TITLE_INSTRUCTION_MODAL,
      {
        instructionId,
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_TITLE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_TITLE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default TitleInstructionBlock;
